import { LandingPageSections } from '../LandingPage.types'
import LoudCrowdButton from '../components/LoudCrowdButton/LoudCrowdButton'

const ambassadorSections: LandingPageSections[] = [
  {
    type: 'hero',
    id: 'hero_section',
    desktopWidth: 'full',
    images: {
      desktop:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1693944676/Dynamic%20Landing%20Pages/Ambassador_desktop_hero_v2.png',
      mobile:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1694542989/Dynamic%20Landing%20Pages/Ambassador_mobile_stacked_hero_v2.png',
    },
    orientation: 'stacked',
    headerText: 'Become a Babylist Ambassador!',
    subHeaderText:
      'Earn site credits when you tag @babylist on Instagram or TikTok!',
    callToAction: {
      type: 'custom_component',
      id: 'loudcrowd_button_hero',
      component: <LoudCrowdButton isInHeroSection />,
    },
  },
  {
    type: 'cards',
    id: 'earn_rewards_section',
    desktopWidth: 'limited',
    imageShape: 'largeRectangle',
    background: 'white',
    headerText: 'Earn Rewards',
    mobileVariant: 'stacked',
    desktopVariant: 'twoColumns',
    cards: [
      {
        type: 'card',
        id: 'one_post_reward_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694013286/Dynamic%20Landing%20Pages/Ambassador_Earn_Rewards_Card1.png',
        headerText: '1 Instagram feed post or reel',
        subHeaderContent: '$5 site credit on a purchase of $40 or more',
      },
      {
        type: 'card',
        id: 'three_posts_reward_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694013287/Dynamic%20Landing%20Pages/Ambassador_Earn_Rewards_Card2.png',
        headerText: '3 Instagram feed posts or reels',
        subHeaderContent: '$25 site credit on a purchase of $40 or more',
      },
      {
        type: 'card',
        id: 'seven_posts_reward_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694013288/Dynamic%20Landing%20Pages/Ambassador_Earn_Rewards_Card3.png',
        headerText: '7 Instagram feed posts or reels',
        subHeaderContent: '$50 site credit',
      },
      {
        type: 'card',
        id: 'tiktok_reward_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694013283/Dynamic%20Landing%20Pages/Ambassador_Earn_Rewards_Card4.png',
        headerText: 'For every TikTok post',
        subHeaderContent: '$15 site credit<br/>*redeemable up to 5 times',
      },
    ],
  },
  {
    type: 'text',
    id: 'challenge_bonus_section',
    desktopWidth: 'full',
    subHeading: 'Challenge Bonus',
    body: 'Earn additional rewards by participating in challenges. Stay tuned!',
    background: 'none',
    includeVerticalSectionSpacing: true,
    sectionAlignment: 'center',
  },
  {
    type: 'spacer',
    id: 'spacer_section_1',
  },
  {
    type: 'divider',
    id: 'divider_section_1',
    variant: 'squiggle',
  },
  {
    type: 'cards',
    id: 'additional_member_perks_section',
    desktopWidth: 'limited',
    imageShape: 'mediumSquare',
    background: 'white',
    headerText: 'Additional Member Perks',
    mobileVariant: 'stacked',
    desktopVariant: 'threeColumns',
    cards: [
      {
        type: 'card',
        id: 'get_featured_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694030161/Dynamic%20Landing%20Pages/Star_Icon.png',
        headerText: 'Get featured',
        subHeaderContent:
          'We love sharing our favorite UGC with our millions of social followers',
      },
      {
        type: 'card',
        id: 'exclusive_challenges_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694030161/Dynamic%20Landing%20Pages/Sunglasses_Icon.png',
        headerText: 'Participate in exclusive challenges',
        subHeaderContent:
          'Participate in challenges and contests to earn surprise rewards',
      },
      {
        type: 'card',
        id: 'community_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694030160/Dynamic%20Landing%20Pages/Peace_Sign_Icon.png',
        headerText: 'Be a part of a community',
        subHeaderContent:
          'Connect with other expecting and new parents and get inspired by each other',
      },
    ],
  },
  {
    type: 'cards',
    id: 'how_it_works_section',
    desktopWidth: 'full',
    imageShape: 'mediumSquare',
    background: 'cream',
    headerText: 'How It Works',
    mobileVariant: 'list',
    desktopVariant: 'threeColumns',
    callToAction: {
      type: 'custom_component',
      id: 'loud_crowd_button_how_to',
      component: <LoudCrowdButton />,
    },
    cards: [
      {
        type: 'card',
        id: 'sign_up_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694101200/Dynamic%20Landing%20Pages/Step1.png',
        headerText: 'Sign Up',
        subHeaderContent:
          'Sign up with your email and Instagram or TikTok handle',
      },
      {
        type: 'card',
        id: 'post_on_social_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694101201/Dynamic%20Landing%20Pages/Step2.png',
        headerText: 'Post On Social',
        subHeaderContent:
          'Create content about Babylist and post on Instagram or TikTok – don&apos;t forget to tag @babylist in every post',
      },
      {
        type: 'card',
        id: 'get_rewarded_card',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1694101201/Dynamic%20Landing%20Pages/Step3.png',
        headerText: 'Get Rewarded',
        subHeaderContent:
          'Complete the tiers and participate in challenges to receive rewards',
      },
    ],
  },
  {
    type: 'feature_highlight',
    id: 'post_rules_section',
    desktopWidth: 'full',
    layout: 'stacked',
    imagePlacement: 'right',
    background: 'none',
    imageUrl:
      'https://images.babylist.com/image/upload/f_auto,q_auto/v1694115187/Dynamic%20Landing%20Pages/Ambassador_Post_Rules.png',
    headerText: 'Post Rules',
    description: {
      content: [
        'You must post an Instagram Feed post or Reel, or TikTok. Instagram Stories do not count toward this program unless explicitly stated for ambassador challenges.',
        'The account you are posting from must be public so we can view your content, and must have previous posts.',
        'Your posts must mention Babylist or show our website, app, Babylist Beverly Hills Showroom, or <a href="/store/b/babylist/873">Babylist-branded products</a>.',
        'You need to tag @babylist in each post.',
        'We take safety seriously. Please maintain safety standards when showing babies or children, including <a href="https://www.aap.org/en/patient-care/safe-sleep/">safe sleep</a>, <a href="/hello-baby/car-seat-safety-answers">car seat safety</a>, <a href="https://www.healthychildren.org/English/ages-stages/baby/bathing-skin-care/Pages/Bathing-Your-Newborn.aspx">bathing</a>, and <a href="https://www.aap.org/en/patient-care/healthy-active-living-for-families/infant-food-and-feeding/">feeding</a> safety.',
      ],
      renderAsListItems: true,
    },
  },
  {
    type: 'divider',
    id: 'divider_section_2',
    variant: 'squiggle',
  },
  {
    type: 'feature_highlight',
    id: 'terms_and_conditions_section',
    desktopWidth: 'full',
    layout: 'stacked',
    imagePlacement: 'left',
    background: 'none',
    imageUrl:
      'https://images.babylist.com/image/upload/f_auto,q_auto/v1694115187/Dynamic%20Landing%20Pages/Ambassador_Terms_and_Conditions.png',
    headerText: 'Terms & Conditions',
    description: {
      content: [
        'To be eligible for rewards, you must: (1) Sign up, and (2) Follow the post rules above',
        'By tagging us in your content, you give permission for your images to be re-shared for marketing purposes, including but not limited to sharing on Babylist&apos;s owned social channels, emails, ads, or on our website',
        'Babylist may update the rewards program at any time',
      ],
      renderAsListItems: true,
    },
  },
  {
    type: 'frequently_asked_questions',
    id: 'frequently_asked_questions_section',
    accordion: true,
    questions: [
      {
        question: 'How do I get rewarded?',
        answer:
          'Ensure you&apos;ve tagged @babylist and are following the post rules above. We will contact you through the email associated with your ambassador account with your reward.',
        id: 'question_1',
      },
      {
        question: 'When should I expect rewards?',
        answer:
          'Instagram Feed posts and Reels will be rewarded at the end of every month. TikTok posts will be rewarded within 24 hours of post approval, and are redeemable up to 5 times. You will be notified by email once your post has been approved.',
        id: 'question_2',
      },
      {
        question: 'What is my reward eligible towards?',
        answer:
          'You will receive your reward in the form of site credit to redeem at babylist.com.',
        id: 'question_3',
      },
      {
        question: 'Can I get rewarded on any other social platforms?',
        answer:
          'While we encourage you to share on other platforms, we are only offering rewards for Instagram and TikTok at this time.',
        id: 'question_4',
      },
      {
        question: 'Are Instagram Stories included?',
        answer:
          'Instagram stories are not included. It is only Feed posts and Reels (and TikToks) at this time.',
        id: 'question_5',
      },
      {
        question: 'How do I ensure my post is valid?',
        answer:
          'It&apos;s super easy: Post from a public account and follow the post rules. Make sure to tag @babylist.',
        id: 'question_6',
      },
      {
        question:
          "Who do I contact if I haven't received my reward or have questions about the program?",
        answer:
          'You can reach out to ambassador@babylist.com with any questions regarding the ambassador program.',
        id: 'question_7',
      },
    ],
  },
]

export default ambassadorSections
